/**
 * The PIM module's permission vocabulary.
 */
import { defineModulePermissions } from '@noissue/authz';

export const PIM = defineModulePermissions({
  // `pim-poc` until this replaces master's proto-PIM, which owns the `pim` id.
  id: 'pim-poc',
  name: 'PIM',
  icon: 'boxes',
  permissions: {
    view: {
      label: 'View the catalog',
      description: 'See products, variants and the attribute catalog.',
    },
    edit: {
      label: 'Edit products and variants',
      description: 'Create and change products, their attribute definitions, and variants.',
    },
    manage: {
      label: 'Manage the attribute catalog',
      description:
        'Add and change the governed attributes and values every product draws on. ' +
        'Edits here reach every product and variant that references them.',
    },
    publish: {
      label: 'Publish to channels',
      description:
        'Decide which variants go live on a sales channel. Orthogonal to editing: ' +
        'enriching a product does not by itself authorise shipping it.',
    },
  },
  visibility: 'view',
  levels: [
    { key: 'view', label: 'View', grants: ['view'] },
    { key: 'edit', label: 'Edit', grants: ['view', 'edit'] },
    { key: 'manage', label: 'Manage', grants: ['view', 'edit', 'manage'] },
  ],
});
